import { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);

  const handleCategoryClick = (slug: string) => {
    navigate(`/category/${slug}`);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 group"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          >
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-book-2-line text-xl text-primary-500"></i>
            </div>
            <span
              className={`font-heading text-lg font-semibold whitespace-nowrap transition-colors ${
                scrolled ? 'text-foreground-900' : 'text-white'
              }`}
            >
              姨母的诱惑
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {categories.slice(0, 4).map((cat) => (
              <button
                key={cat.id}
                onClick={() => handleCategoryClick(cat.slug)}
                className={`px-3 py-2 text-sm rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                  location.pathname === `/category/${cat.slug}`
                    ? scrolled
                      ? 'bg-primary-100 text-primary-700'
                      : 'bg-white/20 text-white'
                    : scrolled
                      ? 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                      : 'text-white/80 hover:text-white hover:bg-white/10'
                }`}
              >
                {cat.name}
              </button>
            ))}
            <Link
              to="/about"
              className={`px-3 py-2 text-sm rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                location.pathname === '/about'
                  ? scrolled
                    ? 'bg-primary-100 text-primary-700'
                    : 'bg-white/20 text-white'
                  : scrolled
                    ? 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                    : 'text-white/80 hover:text-white hover:bg-white/10'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors cursor-pointer ${
              scrolled
                ? 'text-foreground-700 hover:bg-background-100'
                : 'text-white hover:bg-white/10'
            }`}
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-1">
            {categories.map((cat) => (
              <button
                key={cat.id}
                onClick={() => handleCategoryClick(cat.slug)}
                className={`w-full text-left px-3 py-2.5 text-sm rounded-lg transition-colors cursor-pointer ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                }`}
              >
                <div className="w-5 h-5 inline-flex items-center justify-center mr-2">
                  <i className={`${cat.icon} text-sm`}></i>
                </div>
                {cat.name}
              </button>
            ))}
            <Link
              to="/about"
              className={`w-full text-left px-3 py-2.5 text-sm rounded-lg transition-colors ${
                location.pathname === '/about'
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
              }`}
            >
              <div className="w-5 h-5 inline-flex items-center justify-center mr-2">
                <i className="ri-information-line text-sm"></i>
              </div>
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}